import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) {
    nav("/", { replace: true });
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) {
      toast.success("Welcome back");
      nav("/");
    } else {
      toast.error("Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-5 bg-white">
      <div className="hidden lg:flex lg:col-span-3 relative overflow-hidden bg-[#0a0a0a]">
        <img
          src="https://images.unsplash.com/photo-1658298775754-5839ffd434cc?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Solar roof"
          className="absolute inset-0 w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 grid-bg opacity-40" />
        <div className="relative z-10 p-12 flex flex-col justify-between text-white w-full">
          <div className="flex items-center gap-4">
            <img
              src="https://customer-assets.emergentagent.com/job_helios-platform-2/artifacts/zblm1o4j_Multimix%20Energy%20Pvt%20Ltd%20Logo%20%28150%20x%2050%20mm%29%20%281%29.png"
              alt="Multimix Energy"
              className="h-16 w-auto object-contain bg-white p-1"
            />
            <div className="border-l border-white/20 pl-4">
              <div className="label-eyebrow text-white/70">Pvt Ltd</div>
              <div className="font-black tracking-tight text-lg">SOLAR ERP + CRM</div>
            </div>
          </div>
          <div className="space-y-6 max-w-xl">
            <div className="label-eyebrow text-white/60">— Phase 01 / Operations</div>
            <h1 className="text-5xl lg:text-6xl font-black leading-[1.02] tracking-tighter">
              From inquiry<br />to inverter,<br />tracked in one grid.
            </h1>
            <p className="text-white/80 text-base max-w-md">
              The integrated ERP + CRM + Project Management platform built for Indian solar EPC operators.
              Leads, surveys, proposals, projects, tickets — connected end to end.
            </p>
          </div>
          <div className="flex items-end justify-between text-xs uppercase tracking-widest text-white/50">
            <span>v1.0 / Phase 1 MVP</span>
            <span>Kerala · India</span>
          </div>
        </div>
      </div>

      <div className="col-span-1 lg:col-span-2 flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm space-y-8" data-testid="login-form">
          <div>
            <div className="label-eyebrow mb-3">— Sign In</div>
            <h2 className="text-3xl font-black tracking-tight">Operator access</h2>
            <p className="text-sm text-[#4B5563] mt-2">
              Enter your work email and password to continue.
            </p>
          </div>

          <div className="space-y-4">
            <div>
              <Label className="label-eyebrow">Email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-none mt-2 h-11 border-[#0a0a0a]"
                data-testid="login-email-input"
                required
              />
            </div>
            <div>
              <Label className="label-eyebrow">Password</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="rounded-none mt-2 h-11 border-[#0a0a0a]"
                data-testid="login-password-input"
                required
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-none bg-[#002FA7] hover:bg-[#002480] text-white font-bold tracking-wider uppercase text-xs"
            data-testid="login-submit-button"
          >
            {loading ? "Signing in…" : "Enter Command Center →"}
          </Button>
        </form>
      </div>
    </div>
  );
}
